import { render, staticRenderFns } from "./ToQuotes.vue?vue&type=template&id=1256e705&lang=pug&"
import script from "./ToQuotes.vue?vue&type=script&lang=js&"
export * from "./ToQuotes.vue?vue&type=script&lang=js&"
import style0 from "./ToQuotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports